import React from "react";
import {Button} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";

const NotFound404 = () => {
    let history = useHistory();

    const { t } = useTranslation();
    document.title=t("Internal Server Error")
    return (
        <div className="not-found">
            <h2>
                500
            </h2>
            <h4>
                {t("Internal Server Error")}
            </h4>
            <p>
                {t("Looks like an unexpacted problem occured. Please try again or contact the website administrator.")}
            </p>
                <Button className="btn-green" onClick={history.goBack}>
                    {t("Take me back")}
                </Button>
        </div>
    )
}

export default NotFound404